import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useSearchParams, useNavigate } from "react-router-dom";
import validator from "validator";
import { BASEURL } from "../CONSTANTS";
import { Loader } from "../Components/Loader";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { useScreenSize, useCustomScreen } from "../../src/Components/Utils";

export default function SaveNewPassword() {
  const [urlParams] = useSearchParams();
  const [disableSave, setDisableSave] = useState(true);
  const [mainPassword, setMainPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [key, setKey] = useState("");
  const [data, setData] = useState("");
  const [err, setErr] = useState({});
  const navigate = useNavigate();

  const tokenFromCookies = Cookies.get("token");
  const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;

  const { isIpadProPortrait } = useCustomScreen();
  const { logout } = useAuth();
  const { isMediumScreen, is4kScreen } = useScreenSize();

  useEffect(() => {
    setKey(urlParams.get("key"));
  }, [urlParams]);

  const changePWD = async () => {
    try {
      const response = await fetch(`${BASEURL}auth/reset-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({
          key,
          newPassword: mainPassword,
          confirmPassword,
        }),
      });

      const result = await response.text();

      if (response.ok) {
        setData(result);
        setTimeout(() => {
          navigate("/login");
        }, 1000);
        logout();
      } else {
        setData(result);
      }
    } catch (e) {
      console.log(e);
      setErr({ general: "Something went wrong" });
    }
  };

  const savePassword = () => {
    if (mainPassword.trim() !== confirmPassword.trim()) {
      return toast.error("Password and confirm password should match", {
        style: { backgroundColor: "#FFC1B4", color: "red" },
      });
    }
    if (!validator.isStrongPassword(mainPassword)) {
      return toast.error("Please enter strong password", {
        style: { backgroundColor: "#FFC1B4", color: "red" },
      });
    }
    changePWD();
  };

  const mainPasswordChangeHandler = (e) => {
    const { value } = e.target;
    setMainPassword(value);

    if (!value) {
      setErr((prev) => ({ ...prev, password: "Password is required*" }));
      setDisableSave(true);
    } else if (!validator.isStrongPassword(value)) {
      setErr((prev) => ({
        ...prev,
        password:
          "Password must contain uppercase, lowercase, number & special character",
      }));
      setDisableSave(true);
    } else {
      setErr((prev) => ({ ...prev, password: "" }));
      setDisableSave(false);
    }
  };

  const confirmPasswordChangeHandler = (e) => {
    const { value } = e.target;
    setConfirmPassword(value);

    if (!value) {
      setErr((prev) => ({ ...prev, confirmPassword: "Password is required*" }));
      setDisableSave(true);
    } else if (value.trim() !== mainPassword.trim()) {
      setErr((prev) => ({ ...prev, confirmPassword: "Passwords do not match" }));
      setDisableSave(true);
    } else {
      setErr((prev) => ({ ...prev, confirmPassword: "" }));
      setDisableSave(false);
    }
  };

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ marginTop: "5em", minHeight: "80vh", width: "100%" }}
    >
      <Card
        className="shadow-lg d-flex flex-column justify-content-center align-items-center p-4"
        style={{ width: "90%", maxWidth: "500px", borderRadius: "10px" }}
      >
        <Card.Body className="w-100">
          <p className="text-center fs-5 fw-bold mb-4">Change Password</p>

          <Form className="w-100">

            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col md={4} xs={12} className="fw-bold">
                  <Form.Label>Password</Form.Label>
                </Col>
                <Col md={8} xs={12}>
                  <Form.Control
                    type="password"
                    value={mainPassword}
                    onChange={mainPasswordChangeHandler}
                    placeholder="Enter your password"
                  />
                  {err.password && (
                    <div
                      style={{
                        color: "red",
                        fontSize: is4kScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.3rem"
                          : isMediumScreen
                          ? "1rem"
                          : "0.9rem",
                        marginTop: "4px",
                      }}
                    >
                      {err.password}
                    </div>
                  )}
                </Col>
              </Row>
            </Form.Group>


            <Form.Group className="mb-3">
              <Row className="align-items-center">
                <Col md={4} xs={12} className="fw-bold">
                  <Form.Label>Confirm Password</Form.Label>
                </Col>
                <Col md={8} xs={12}>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    onChange={confirmPasswordChangeHandler}
                    placeholder="Confirm your password"
                  />
                  {err.confirmPassword && (
                    <div
                      style={{
                        color: "red",
                        fontSize: is4kScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.3rem"
                          : isMediumScreen
                          ? "1rem"
                          : "0.9rem",
                        marginTop: "4px",
                      }}
                    >
                      {err.confirmPassword}
                    </div>
                  )}
                </Col>
              </Row>
            </Form.Group>

            <div className="text-center">
              {data ? (
                <p style={{ color: "green", fontWeight: "bold" }}>
                  Password Changed Successfully
                </p>
              ) : err.general ? (
                <p style={{ color: "red", fontWeight: "bold" }}>
                  {err.general}
                </p>
              ) : null}
            </div>

            {/* Submit Button */}
            <div className="d-flex justify-content-center align-items-center mt-3">
              <button
                type="button"
                className="login-btns btn mb-3 d-flex justify-content-center align-items-center"
                disabled={disableSave}
                onClick={savePassword}
                style={{ height: "2.5rem" }}
              >
                <Loader action="Save" />
              </button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
